<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Llama-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'All Expenses'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<div data-content-area="content" data-defined-in="Llama.AllExpenses">
							<div
								class="layout-block vertical"
								style="padding: 1rem"
								[style.align-items]="'inherit'"
								[style.gap]="'1em'"
							>
								<mat-card>
									<mat-card-content>
										<div style="display: inline-block">
											<mat-form-field
												class="has-dateChange-handler"
												appearance="outline"
												(dateChange)="handler_DatePickerBlock_27_dateChange_loadExpenses_0($event, {  })"
												class="fill"
											>
												@let $fc_27_1 = getFormControl(screen, 'filterDate',
												27, $scope, $formDirective, $disabled,
												$ignoreValidations);
												<mat-label
													[innerHtml]="'Date' | escapeHtml"
												></mat-label>
												<input
													class="has-dateChange-handler"
													(dateChange)="handler_DatePickerBlock_27_dateChange_loadExpenses_0($event, {  })"
													matInput
													[formControl]="$fc_27_1"
													[matDatepicker]="picker637861"
												/>
												<mat-datepicker-toggle
													matSuffix
													[for]="picker637861"
												></mat-datepicker-toggle>
												<mat-datepicker #picker637861></mat-datepicker>
												@for(error of $fc_27_1.errors ?? {} | keyvalue;
												track error.key) {
												<mat-error
													*ngIf="typeof error.value == 'string'"
													[innerHtml]="error.value | escapeHtml: 'safe'"
												/>
												}
											</mat-form-field>
										</div>
										<mat-form-field
											class="has-selectionChange-handler"
											appearance="outline"
											style="margin-left: 0.5em"
											(selectionChange)="handler_DropdownBlock_28_selectionChange_loadExpenses_0($event, {  })"
										>
											@let $fc_28_1 = getFormControl(screen,
											'filterProjectId', 28, $scope, $formDirective,
											$disabled, $ignoreValidations);

											<mat-label
												[innerHtml]="'Projects' | escapeHtml"
											></mat-label>
											<mat-select
												class="has-selectionChange-handler"
												(selectionChange)="handler_DropdownBlock_28_selectionChange_loadExpenses_0($event, {  })"
												[formControl]="$fc_28_1"
												[compareWith]="$compare"
												#select_28="matSelect"
												[lgFormComponent]="select_28"
												[lgFormValue]="screen.filterProjectId"
												canSelectNullableOptions
											>
												@let emptyOption_28 = [null, 'All Projects', true];
												@if (emptyOption_28) {
												<mat-option [value]="emptyOption_28[0]"
													>{{ emptyOption_28[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (screen.projectsOptions); let $index = index"
													[value]="$option.id"
												>
													<span
														[innerHtml]="$option.name | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_28_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field
											*ngIf="$any(screen.filterProjectId)?.$isOther"
										>
											@let $fc_28_3 = getFormControl(screen.filterProjectId,
											'$otherValue', 28, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Projects' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_28_3" />
										</mat-form-field>

										<mat-form-field
											class="has-selectionChange-handler"
											appearance="outline"
											style="margin-left: 0.5em"
											(selectionChange)="handler_DropdownBlock_44_selectionChange_loadExpenses_0($event, {  })"
										>
											@let $fc_44_1 = getFormControl(screen, 'filterStatus',
											44, $scope, $formDirective, $disabled,
											$ignoreValidations);

											<mat-label
												[innerHtml]="'Status' | escapeHtml"
											></mat-label>
											<mat-select
												class="has-selectionChange-handler"
												(selectionChange)="handler_DropdownBlock_44_selectionChange_loadExpenses_0($event, {  })"
												[formControl]="$fc_44_1"
												[compareWith]="$compare"
												#select_44="matSelect"
												[lgFormComponent]="select_44"
												[lgFormValue]="screen.filterStatus"
												canSelectNullableOptions
											>
												@let emptyOption_44 = [null, 'All Statuses', true];
												@if (emptyOption_44) {
												<mat-option [value]="emptyOption_44[0]"
													>{{ emptyOption_44[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (This.ExpenseStatus.getChoices()); let $index = index"
													[value]="$option.id"
												>
													<span
														[innerHtml]="$option.label | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_44_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field *ngIf="$any(screen.filterStatus)?.$isOther">
											@let $fc_44_3 = getFormControl(screen.filterStatus,
											'$otherValue', 44, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Status' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_44_3" />
										</mat-form-field>

										<mat-form-field
											class="has-selectionChange-handler"
											appearance="outline"
											style="margin-left: 0.5em"
											(selectionChange)="handler_DropdownBlock_45_selectionChange_loadExpenses_0($event, {  })"
										>
											@let $fc_45_1 = getFormControl(screen, 'filterEmployee',
											45, $scope, $formDirective, $disabled,
											$ignoreValidations);

											<mat-label
												[innerHtml]="'Employee' | escapeHtml"
											></mat-label>
											<mat-select
												class="has-selectionChange-handler"
												(selectionChange)="handler_DropdownBlock_45_selectionChange_loadExpenses_0($event, {  })"
												[formControl]="$fc_45_1"
												[compareWith]="$compare"
												#select_45="matSelect"
												[lgFormComponent]="select_45"
												[lgFormValue]="screen.filterEmployee"
												canSelectNullableOptions
											>
												@let emptyOption_45 = [null, 'All Employees', true];
												@if (emptyOption_45) {
												<mat-option [value]="emptyOption_45[0]"
													>{{ emptyOption_45[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (screen.employeesOptions); let $index = index"
													[value]="$option"
												>
													<span
														[innerHtml]="$option | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_45_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field
											*ngIf="$any(screen.filterEmployee)?.$isOther"
										>
											@let $fc_45_3 = getFormControl(screen.filterEmployee,
											'$otherValue', 45, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Employee' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_45_3" />
										</mat-form-field>

										<mat-form-field
											class="has-selectionChange-handler"
											appearance="outline"
											style="margin-left: 0.5em"
											(selectionChange)="handler_DropdownBlock_46_selectionChange_loadExpenses_0($event, {  })"
										>
											@let $fc_46_1 = getFormControl(screen,
											'filterChargeability', 46, $scope, $formDirective,
											$disabled, $ignoreValidations);

											<mat-label
												[innerHtml]="'Is chargeable' | escapeHtml"
											></mat-label>
											<mat-select
												class="has-selectionChange-handler"
												(selectionChange)="handler_DropdownBlock_46_selectionChange_loadExpenses_0($event, {  })"
												[formControl]="$fc_46_1"
												[compareWith]="$compare"
												#select_46="matSelect"
												[lgFormComponent]="select_46"
												[lgFormValue]="screen.filterChargeability"
												canSelectNullableOptions
											>
												@let emptyOption_46 = [null, 'Both', true]; @if
												(emptyOption_46) {
												<mat-option [value]="emptyOption_46[0]"
													>{{ emptyOption_46[1] }}</mat-option
												>
												}

												<mat-option
													*ngFor="let $option of (screen.chargeabilitiesOptions); let $index = index"
													[value]="$option.id"
												>
													<span
														[innerHtml]="$option.label | escapeHtml"
														style="margin: auto 0"
													></span>
												</mat-option>
											</mat-select>

											@for(error of $fc_46_1.errors ?? {} | keyvalue; track
											error.key) {
											<mat-error
												*ngIf="typeof error.value == 'string'"
												[innerHtml]="error.value | escapeHtml: 'safe'"
											/>
											}
										</mat-form-field>
										<mat-form-field
											*ngIf="$any(screen.filterChargeability)?.$isOther"
										>
											@let $fc_46_3 =
											getFormControl(screen.filterChargeability,
											'$otherValue', 46, $scope, $formDirective, $disabled,
											$ignoreValidations);
											<mat-label
												[innerHtml]="'Is chargeable' + ' (Other)' | escapeHtml"
											></mat-label>
											<input type="text" matInput [formControl]="$fc_46_3" />
										</mat-form-field>

										<lowgile-table
											#datatable_34
											[dataSignal]="_DataTableBlock_collectionCodeSignal_34(datatable_34, { app, screen, $pathSegments, $disabled })"
											[trackBy]="trackByAutomatic"
											[entity]="This.Expense"
											[columns]="_DataTableBlock_columns_34(screen)"
											[showSettings]="true"
											[userDefinedConfiguration]="undefined"
											[usePaging]="true"
											[pageSize]="20"
											[pageSizeOptions]="[10, 20, 50]"
											[useGlobalFilter]="false"
											[debouncingDelay]="250"
											[stickyHeader]="true"
											[additionalFindOptions]="_DataTableBlock_additionalFindOptions_34({ app, screen, $pathSegments, $disabled })"
											[additionalHeaderRows]="[]"
											[additionalFooterRows]="[]"
											[allClasses]="$Modules"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[surroundingScope]="$scope"
											#$table_34="lowgileTable"
										>
											<ng-container [lowgile-column]="'expenseDate'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Expense Date' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Expense Date'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_35({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('expenseDate') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'name'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Name' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Name'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_36({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container [lowgile-column]="('name') + '$$filter'">
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'status'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Status' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Status'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_43({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('status') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'project'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Project' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Project'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_42({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('project') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'employee'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Employee' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Employee'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_47({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('employee') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'category'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Category' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Category'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_37({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('category') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'currency'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Currency' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Currency'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_38({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('currency') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'vatAmount'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'VAT' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'VAT'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_39({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('vatAmount') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'tipAmount'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Tip' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Tip'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_40({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('tipAmount') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>

											<ng-container [lowgile-column]="'totalAmount'">
												<th mat-header-cell *matHeaderCellDef>
													<span
														[innerHtml]="'Total' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</th>
												<td
													mat-cell
													*matCellDef="let item; let index = index"
													[attr.data-label]="'Total'"
												>
													<ng-container
														*lowgileScope="item; as: 'item'; let $scope"
													>
														<ng-container
															*lowgileScope="index; as: 'index'; let $scope"
														>
															<span
																[innerHtml]="_DataTableColumnBlock_cellText_41({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</ng-container>
													</ng-container>
												</td>
											</ng-container>
											<ng-container
												[lowgile-column]="('totalAmount') + '$$filter'"
											>
												<th mat-header-cell *matHeaderCellDef></th>
											</ng-container>
										</lowgile-table>
									</mat-card-content>
								</mat-card>
							</div>
						</div>
					</ng-template>
				</Llama-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
